import h from 'react-hyperscript';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-grid.css';
import 'bootstrap/dist/css/bootstrap-reboot.css';
import 'font-awesome/css/font-awesome.css';

import registerServiceWorker from './registerServiceWorker';

import { AppContainer } from './containers';

render(h(Router, {}, h(AppContainer)), document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js